// // import React, { useRef } from "react";
// // import Button from "../../Buttons/Button";
// // import Divider from "../../Common/Divider";
// // import DropdownMenu from "../../Buttons/DropdownMenu";

// // const CustomTextEditor = ({ placeholder = "Type Here" }) => {
// //   const editorRef = useRef(null);

// //   const ToolButton = ({ icon, onClick, active }) => (
// //     <Button
// //       type="icon"
// //       icon={icon}
// //       color={active ? "primary" : "black"}
// //       variant="text"
// //       size="sm"
// //       onClick={onClick}
// //       className="rounded-none"
// //     />
// //   );
// //   const DropdonwButton = ({ title, icon, onClick, active }) => (
// //     <Button
// //       title={title}
// //       variant="text"
// //       color={active ? "primary" : "black"}
// //       icon={icon}
// //       onClick={onClick}
// //       size="sm"
// //       className="w-full !py-1 !px-1.5"
// //       fromLeft
// //     />
// //   );

// //   return (
// //     <div className="w-full flex-1 flex flex-col my-2 overflow-auto">
// //       <div className="toolbar bg-gray-200 p-2 flex gap-1 flex-wrap">
// //         <div className="flex gap-1 items-center">
// //           <ToolButton icon="format_bold" />
// //           <ToolButton icon="format_italic" />
// //           <ToolButton icon="format_underlined" />
// //           <ToolButton icon="subscript" />
// //           <ToolButton icon="superscript" />
// //           <ToolButton icon="format_clear" />
// //         </div>
// //         <Divider orientation="vertical" />
// //         <div className="flex flex-wrap gap-1 items-center">
// //           <DropdownMenu
// //             MenuSection={
// //               <div className="p-2 flex flex-col gap-1">
// //                 <DropdonwButton title={"Header 1"} icon="format_h1" />
// //                 <DropdonwButton title={"Header 2"} icon="format_h2" />
// //                 <DropdonwButton title={"Header 3"} icon="format_h3" />
// //                 <DropdonwButton title={"Header 4"} icon="format_h4" />
// //                 <DropdonwButton title={"Header 5"} icon="format_h5" />
// //                 <DropdonwButton title={"Header 6"} icon="format_h6" />
// //               </div>
// //             }
// //           >
// //             <Button
// //               type="icon"
// //               variant="text"
// //               color="black"
// //               icon="text_format"
// //               size="sm"
// //               className="rounded-none gap-0.5 !px-5"
// //               ddMenu
// //             />
// //           </DropdownMenu>
// //           <DropdownMenu
// //             MenuSection={
// //               <div className="p-2 flex flex-col gap-1">
// //                 <DropdonwButton title={"Arial"} />
// //                 <DropdonwButton title={"Times New Roman"} />
// //                 <DropdonwButton title={"Courier New"} />
// //                 <DropdonwButton title={"Verdana"} />
// //                 <DropdonwButton title={"Georgia"} />
// //                 <DropdonwButton title={"Tahoma"} />
// //               </div>
// //             }
// //           >
// //             <Button
// //               type="icon"
// //               variant="text"
// //               color="black"
// //               icon="serif"
// //               size="sm"
// //               className="rounded-none gap-0.5 !px-5"
// //               ddMenu
// //             />
// //           </DropdownMenu>
// //           <DropdownMenu
// //             MenuSection={
// //               <div className="p-2 flex flex-col gap-1">
// //                 <DropdonwButton title={"Font Size 10"} />
// //                 <DropdonwButton title={"Font Size 12"} />
// //                 <DropdonwButton title={"Font Size 14"} />
// //                 <DropdonwButton title={"Font Size 16"} />
// //                 <DropdonwButton title={"Font Size 18"} />
// //                 <DropdonwButton title={"Font Size 20"} />
// //                 <DropdonwButton title={"Font Size 24"} />
// //               </div>
// //             }
// //           >
// //             <Button
// //               type="icon"
// //               variant="text"
// //               color="black"
// //               icon="text_fields"
// //               size="sm"
// //               className="rounded-none gap-0.5 !px-5"
// //               ddMenu
// //             />
// //           </DropdownMenu>
// //           <DropdownMenu
// //             MenuSection={
// //               <div className="p-2 flex flex-col gap-1">
// //                 <DropdonwButton title={"Line Height 1"} />
// //                 <DropdonwButton title={"Line Height 1.2"} />
// //                 <DropdonwButton title={"Line Height 1.4"} />
// //                 <DropdonwButton title={"Line Height 1.6"} />
// //                 <DropdonwButton title={"Line Height 1.8"} />
// //                 <DropdonwButton title={"Line Height 2"} />
// //               </div>
// //             }
// //           >
// //             <Button
// //               type="icon"
// //               variant="text"
// //               color="black"
// //               icon="line_weight"
// //               size="sm"
// //               className="rounded-none gap-0.5 !px-5"
// //               ddMenu
// //             />
// //           </DropdownMenu>
// //         </div>
// //         <Divider orientation="vertical" />
// //         <div className="flex gap-1 items-center">
// //           <ToolButton icon="add_link" />
// //           <ToolButton icon="photo" />
// //           <ToolButton icon="videocam" />
// //           <ToolButton icon="attach_file_add" />
// //           <ToolButton icon="format_list_bulleted" />
// //           <ToolButton icon="format_list_numbered" />
// //           <ToolButton icon="format_quote" />
// //           <ToolButton icon="format_color_text" />
// //           <ToolButton icon="format_color_fill" />
// //         </div>
// //         <div className="flex gap-1 items-center">
// //           <ToolButton icon="format_align_left" />
// //           <ToolButton icon="format_align_center" />
// //           <ToolButton icon="format_align_right" />
// //           <ToolButton icon="format_align_justify" />
// //           <ToolButton icon="format_indent_increase" />
// //           <ToolButton icon="format_indent_decrease" />
// //         </div>
// //         <Divider orientation="vertical" />
// //       </div>
// //       <div className="textArea bg-gray-50 border border-gray-200 p-2 min-h-[200px]">
// //         <div
// //           ref={editorRef}
// //           className="editor-content w-full min-h-[180px] max-h-[600px] outline-none resize-y overflow-auto"
// //           contentEditable
// //           placeholder={placeholder}
// //           suppressContentEditableWarning
// //         />
// //       </div>
// //       <div className="textAreaBottom bg-gray-200 p-2">asd</div>
// //     </div>
// //   );
// // };

// // export default CustomTextEditor;

// import React, { useRef, useState, useCallback, useEffect } from "react";
// import Button from "../../Buttons/Button";

// const CustomTextEditor = ({
//   placeholder = "Type Here",
//   onChange,
//   initialContent = "",
// }) => {
//   const editorRef = useRef(null);
//   const [activeFormats, setActiveFormats] = useState(new Set());
//   const [selectedFont, setSelectedFont] = useState("Arial");
//   const [selectedFontSize, setSelectedFontSize] = useState("14");
//   const [selectedLineHeight, setSelectedLineHeight] = useState("1.4");

//   // Handle content changes
//   const handleContentChange = useCallback(() => {
//     if (editorRef.current && onChange) {
//       onChange(editorRef.current.innerHTML);
//     }
//     updateActiveFormats();
//   }, [onChange]);

//   // Update active formats based on cursor position
//   const updateActiveFormats = useCallback(() => {
//     const formats = new Set();

//     if (document.queryCommandState("bold")) formats.add("bold");
//     if (document.queryCommandState("italic")) formats.add("italic");
//     if (document.queryCommandState("underline")) formats.add("underline");
//     if (document.queryCommandState("subscript")) formats.add("subscript");
//     if (document.queryCommandState("superscript")) formats.add("superscript");
//     if (document.queryCommandState("insertUnorderedList"))
//       formats.add("bulletList");
//     if (document.queryCommandState("insertOrderedList"))
//       formats.add("numberedList");
//     if (document.queryCommandState("justifyLeft")) formats.add("alignLeft");
//     if (document.queryCommandState("justifyCenter")) formats.add("alignCenter");
//     if (document.queryCommandState("justifyRight")) formats.add("alignRight");
//     if (document.queryCommandState("justifyFull")) formats.add("alignJustify");

//     setActiveFormats(formats);
//   }, []);

//   // Execute formatting commands
//   const executeCommand = useCallback(
//     (command, value = null) => {
//       document.execCommand(command, false, value);
//       editorRef.current?.focus();
//       updateActiveFormats();
//       handleContentChange();
//     },
//     [handleContentChange, updateActiveFormats]
//   );

//   // Handle special commands
//   const handleSpecialCommand = useCallback(
//     (action, value) => {
//       switch (action) {
//         case "fontSize":
//           executeCommand("fontSize", "3");
//           const selection = window.getSelection();
//           if (selection.rangeCount > 0) {
//             const range = selection.getRangeAt(0);
//             const span = document.createElement("span");
//             span.style.fontSize = value + "px";
//             try {
//               range.surroundContents(span);
//             } catch (e) {
//               span.appendChild(range.extractContents());
//               range.insertNode(span);
//             }
//           }
//           setSelectedFontSize(value);
//           break;
//         case "fontFamily":
//           executeCommand("fontName", value);
//           setSelectedFont(value);
//           break;
//         case "lineHeight":
//           const sel = window.getSelection();
//           if (sel.rangeCount > 0) {
//             const range = sel.getRangeAt(0);
//             const div = document.createElement("div");
//             div.style.lineHeight = value;
//             try {
//               range.surroundContents(div);
//             } catch (e) {
//               div.appendChild(range.extractContents());
//               range.insertNode(div);
//             }
//           }
//           setSelectedLineHeight(value);
//           break;
//         case "heading":
//           executeCommand("formatBlock", value);
//           break;
//         case "link":
//           const url = prompt("Enter URL:");
//           if (url) executeCommand("createLink", url);
//           break;
//         case "image":
//           const imgUrl = prompt("Enter image URL:");
//           if (imgUrl) executeCommand("insertImage", imgUrl);
//           break;
//         case "clearFormat":
//           executeCommand("removeFormat");
//           executeCommand("unlink");
//           break;
//         default:
//           executeCommand(action, value);
//       }
//       handleContentChange();
//     },
//     [executeCommand, handleContentChange]
//   );

//   // Initialize content
//   useEffect(() => {
//     if (editorRef.current && initialContent) {
//       editorRef.current.innerHTML = initialContent;
//     }
//   }, [initialContent]);

//   // Handle selection change
//   useEffect(() => {
//     const handleSelectionChange = () => {
//       updateActiveFormats();
//     };

//     document.addEventListener("selectionchange", handleSelectionChange);
//     return () =>
//       document.removeEventListener("selectionchange", handleSelectionChange);
//   }, [updateActiveFormats]);

//   const ToolButton = ({ icon, onClick, active, title }) => (
//     // <button
//     //   className={`p-2 rounded hover:bg-gray-300 transition-colors ${
//     //     active ? "bg-blue-200 text-blue-700" : "text-gray-700"
//     //   }`}
//     //   onClick={onClick}
//     //   title={title}
//     //   type="button"
//     // >
//     //   <span className="material-icons text-sm">{icon}</span>
//     // </button>
//     <Button
//       title={title}
//       type="icon"
//       icon={icon}
//       color={active ? "primary" : "black"}
//       variant="text"
//       size="sm"
//       onClick={onClick}
//       className="rounded-none"
//     />
//   );

//   const DropdownButton = ({ children, title }) => {
//     const [isOpen, setIsOpen] = useState(false);

//     return (
//       <div className="relative">
//         <button
//           className="p-2 rounded hover:bg-gray-300 transition-colors text-gray-700 flex items-center gap-1"
//           onClick={() => setIsOpen(!isOpen)}
//           type="button"
//         >
//           <span className="material-icons text-sm">{title}</span>
//           <span className="material-icons text-xs">arrow_drop_down</span>
//         </button>
//         {isOpen && (
//           <>
//             <div
//               className="fixed inset-0 z-10"
//               onClick={() => setIsOpen(false)}
//             />
//             <div className="absolute top-full left-0 bg-white border border-gray-300 rounded shadow-lg z-20 min-w-48">
//               {children}
//             </div>
//           </>
//         )}
//       </div>
//     );
//   };

//   const DropdownItem = ({ children, onClick }) => (
//     <button
//       className="w-full text-left px-3 py-2 hover:bg-gray-100 transition-colors"
//       onClick={onClick}
//       type="button"
//     >
//       {children}
//     </button>
//   );

//   return (
//     <div className="w-full flex flex-col border border-gray-300 rounded-lg overflow-hidden bg-white">
//       {/* Toolbar */}
//       <div className="bg-gray-100 p-2 border-b border-gray-300">
//         <div className="flex flex-wrap gap-1 items-center">
//           {/* Basic formatting */}
//           <div className="flex gap-1 items-center">
//             <ToolButton
//               icon="format_bold"
//               onClick={() => handleSpecialCommand("bold")}
//               active={activeFormats.has("bold")}
//               title="Bold"
//             />
//             <ToolButton
//               icon="format_italic"
//               onClick={() => handleSpecialCommand("italic")}
//               active={activeFormats.has("italic")}
//               title="Italic"
//             />
//             <ToolButton
//               icon="format_underlined"
//               onClick={() => handleSpecialCommand("underline")}
//               active={activeFormats.has("underline")}
//               title="Underline"
//             />
//             <ToolButton
//               icon="format_strikethrough"
//               onClick={() => handleSpecialCommand("strikeThrough")}
//               active={activeFormats.has("strikeThrough")}
//               title="Strikethrough"
//             />
//           </div>

//           <div className="w-px h-6 bg-gray-400 mx-1" />

//           {/* Headings */}
//           <DropdownButton title="text_format">
//             <DropdownItem onClick={() => handleSpecialCommand("heading", "h1")}>
//               <h1 className="text-xl font-bold">Heading 1</h1>
//             </DropdownItem>
//             <DropdownItem onClick={() => handleSpecialCommand("heading", "h2")}>
//               <h2 className="text-lg font-bold">Heading 2</h2>
//             </DropdownItem>
//             <DropdownItem onClick={() => handleSpecialCommand("heading", "h3")}>
//               <h3 className="text-base font-bold">Heading 3</h3>
//             </DropdownItem>
//             <DropdownItem onClick={() => handleSpecialCommand("heading", "p")}>
//               <p>Normal text</p>
//             </DropdownItem>
//           </DropdownButton>

//           {/* Font family */}
//           <DropdownButton title="font_download">
//             {[
//               "Arial",
//               "Times New Roman",
//               "Courier New",
//               "Verdana",
//               "Georgia",
//               "Tahoma",
//             ].map((font) => (
//               <DropdownItem
//                 key={font}
//                 onClick={() => handleSpecialCommand("fontFamily", font)}
//               >
//                 <span style={{ fontFamily: font }}>{font}</span>
//               </DropdownItem>
//             ))}
//           </DropdownButton>

//           {/* Font size */}
//           <DropdownButton title="text_fields">
//             {["10", "12", "14", "16", "18", "20", "24", "28", "32"].map(
//               (size) => (
//                 <DropdownItem
//                   key={size}
//                   onClick={() => handleSpecialCommand("fontSize", size)}
//                 >
//                   <span style={{ fontSize: size + "px" }}>Size {size}</span>
//                 </DropdownItem>
//               )
//             )}
//           </DropdownButton>

//           <div className="w-px h-6 bg-gray-400 mx-1" />

//           {/* Lists and alignment */}
//           <div className="flex gap-1 items-center">
//             <ToolButton
//               icon="format_list_bulleted"
//               onClick={() => handleSpecialCommand("insertUnorderedList")}
//               active={activeFormats.has("bulletList")}
//               title="Bullet List"
//             />
//             <ToolButton
//               icon="format_list_numbered"
//               onClick={() => handleSpecialCommand("insertOrderedList")}
//               active={activeFormats.has("numberedList")}
//               title="Numbered List"
//             />
//           </div>

//           <div className="w-px h-6 bg-gray-400 mx-1" />

//           {/* Alignment */}
//           <div className="flex gap-1 items-center">
//             <ToolButton
//               icon="format_align_left"
//               onClick={() => handleSpecialCommand("justifyLeft")}
//               active={activeFormats.has("alignLeft")}
//               title="Align Left"
//             />
//             <ToolButton
//               icon="format_align_center"
//               onClick={() => handleSpecialCommand("justifyCenter")}
//               active={activeFormats.has("alignCenter")}
//               title="Align Center"
//             />
//             <ToolButton
//               icon="format_align_right"
//               onClick={() => handleSpecialCommand("justifyRight")}
//               active={activeFormats.has("alignRight")}
//               title="Align Right"
//             />
//             <ToolButton
//               icon="format_align_justify"
//               onClick={() => handleSpecialCommand("justifyFull")}
//               active={activeFormats.has("alignJustify")}
//               title="Justify"
//             />
//           </div>

//           <div className="w-px h-6 bg-gray-400 mx-1" />

//           {/* Additional tools */}
//           <div className="flex gap-1 items-center">
//             <ToolButton
//               icon="link"
//               onClick={() => handleSpecialCommand("link")}
//               title="Insert Link"
//             />
//             <ToolButton
//               icon="image"
//               onClick={() => handleSpecialCommand("image")}
//               title="Insert Image"
//             />
//             <ToolButton
//               icon="format_clear"
//               onClick={() => handleSpecialCommand("clearFormat")}
//               title="Clear Formatting"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Editor */}
//       <div className="flex-1 min-h-64">
//         <div
//           ref={editorRef}
//           className="w-full h-full p-4 outline-none resize-none overflow-auto focus:ring-0"
//           contentEditable
//           suppressContentEditableWarning
//           placeholder={placeholder}
//           onInput={handleContentChange}
//           onKeyUp={updateActiveFormats}
//           onMouseUp={updateActiveFormats}
//           style={{
//             minHeight: "16rem",
//             lineHeight: selectedLineHeight,
//             fontFamily: selectedFont,
//             fontSize: selectedFontSize + "px",
//           }}
//         />
//       </div>

//       {/* Status bar */}
//       <div className="bg-gray-50 px-4 py-2 text-sm text-gray-600 border-t border-gray-300">
//         <div className="flex justify-between items-center">
//           <span>Rich Text Editor</span>
//           <span>
//             {selectedFont} • {selectedFontSize}px • Line height:{" "}
//             {selectedLineHeight}
//           </span>
//         </div>
//       </div>

//       {/* Add Material Icons if not already included */}
//     </div>
//   );
// };

// export default CustomTextEditor;

import React, { useRef, useState, useCallback, useEffect } from "react";

const CustomTextEditor = ({
  placeholder = "Type Here",
  onChange,
  initialContent = "",
}) => {
  const editorRef = useRef(null);
  const [activeFormats, setActiveFormats] = useState(new Set());
  const [selectedFont, setSelectedFont] = useState("Arial");
  const [selectedFontSize, setSelectedFontSize] = useState("14");
  const [selectedLineHeight, setSelectedLineHeight] = useState("1.4");

  // Handle content changes
  const handleContentChange = useCallback(() => {
    if (editorRef.current && onChange) {
      onChange(editorRef.current.innerHTML);
    }
    updateActiveFormats();
  }, [onChange]);

  // Update active formats based on cursor position
  const updateActiveFormats = useCallback(() => {
    const formats = new Set();

    if (document.queryCommandState("bold")) formats.add("bold");
    if (document.queryCommandState("italic")) formats.add("italic");
    if (document.queryCommandState("underline")) formats.add("underline");
    if (document.queryCommandState("subscript")) formats.add("subscript");
    if (document.queryCommandState("superscript")) formats.add("superscript");
    if (document.queryCommandState("insertUnorderedList"))
      formats.add("bulletList");
    if (document.queryCommandState("insertOrderedList"))
      formats.add("numberedList");
    if (document.queryCommandState("justifyLeft")) formats.add("alignLeft");
    if (document.queryCommandState("justifyCenter")) formats.add("alignCenter");
    if (document.queryCommandState("justifyRight")) formats.add("alignRight");
    if (document.queryCommandState("justifyFull")) formats.add("alignJustify");

    setActiveFormats(formats);
  }, []);

  // Execute formatting commands
  const executeCommand = useCallback(
    (command, value = null) => {
      document.execCommand(command, false, value);
      editorRef.current?.focus();
      updateActiveFormats();
      handleContentChange();
    },
    [handleContentChange, updateActiveFormats]
  );

  // Handle special commands
  const handleSpecialCommand = useCallback(
    (action, value) => {
      switch (action) {
        case "fontSize":
          executeCommand("fontSize", "3");
          const selection = window.getSelection();
          if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const span = document.createElement("span");
            span.style.fontSize = value + "px";
            try {
              range.surroundContents(span);
            } catch (e) {
              span.appendChild(range.extractContents());
              range.insertNode(span);
            }
          }
          setSelectedFontSize(value);
          break;
        case "fontFamily":
          executeCommand("fontName", value);
          setSelectedFont(value);
          break;
        case "lineHeight":
          const sel = window.getSelection();
          if (sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            const div = document.createElement("div");
            div.style.lineHeight = value;
            try {
              range.surroundContents(div);
            } catch (e) {
              div.appendChild(range.extractContents());
              range.insertNode(div);
            }
          }
          setSelectedLineHeight(value);
          break;
        case "heading":
          executeCommand("formatBlock", value);
          break;
        case "link":
          const url = prompt("Enter URL:");
          if (url) executeCommand("createLink", url);
          break;
        case "image":
          const imgUrl = prompt("Enter image URL:");
          if (imgUrl) executeCommand("insertImage", imgUrl);
          break;
        case "clearFormat":
          executeCommand("removeFormat");
          executeCommand("unlink");
          break;
        default:
          executeCommand(action, value);
      }
      handleContentChange();
    },
    [executeCommand, handleContentChange]
  );

  // Initialize content
  useEffect(() => {
    if (editorRef.current && initialContent) {
      editorRef.current.innerHTML = initialContent;
    }
  }, [initialContent]);

  // Handle selection change
  useEffect(() => {
    const handleSelectionChange = () => {
      updateActiveFormats();
    };

    document.addEventListener("selectionchange", handleSelectionChange);
    return () =>
      document.removeEventListener("selectionchange", handleSelectionChange);
  }, [updateActiveFormats]);

  // Custom Button Component
  const Button = ({
    type,
    icon,
    color,
    variant,
    size,
    onClick,
    className,
    title,
    ddMenu,
    fromLeft,
    children,
  }) => {
    const baseClasses =
      "inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
    const sizeClasses = {
      sm: "px-2 py-1 text-sm",
      md: "px-3 py-2 text-base",
      lg: "px-4 py-3 text-lg",
    };
    const colorClasses = {
      primary:
        variant === "text"
          ? "text-blue-600 hover:text-blue-700 hover:bg-blue-50"
          : "bg-blue-600 text-white hover:bg-blue-700",
      black:
        variant === "text"
          ? "text-gray-700 hover:text-gray-900 hover:bg-gray-100"
          : "bg-gray-800 text-white hover:bg-gray-900",
    };

    return (
      <button
        className={`${baseClasses} ${sizeClasses[size || "md"]} ${
          colorClasses[color || "black"]
        } ${className || ""}`}
        onClick={onClick}
        title={title}
      >
        {icon && <span className="material-icons text-sm mr-1">{icon}</span>}
        {title && fromLeft && <span>{title}</span>}
        {children}
        {ddMenu && (
          <span className="material-icons text-xs ml-1">arrow_drop_down</span>
        )}
      </button>
    );
  };

  // Custom Divider Component
  const Divider = ({ orientation }) => (
    <div
      className={
        orientation === "vertical"
          ? "w-px h-6 bg-gray-300 mx-1"
          : "h-px w-full bg-gray-300 my-1"
      }
    />
  );

  // Custom DropdownMenu Component
  const DropdownMenu = ({ children, MenuSection }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="relative">
        <div onClick={() => setIsOpen(!isOpen)}>{children}</div>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-10"
              onClick={() => setIsOpen(false)}
            />
            <div className="absolute top-full left-0 bg-white border border-gray-300 rounded shadow-lg z-20 min-w-48">
              {MenuSection}
            </div>
          </>
        )}
      </div>
    );
  };

  const ToolButton = ({ icon, onClick, active, title }) => (
    <Button
      type="icon"
      icon={icon}
      color={active ? "primary" : "black"}
      variant="text"
      size="sm"
      onClick={onClick}
      className="rounded-none"
      title={title}
    />
  );

  const DropdownButton = ({ title, icon, onClick, active }) => (
    <Button
      title={title}
      variant="text"
      color={active ? "primary" : "black"}
      icon={icon}
      onClick={onClick}
      size="sm"
      className="w-full !py-1 !px-1.5"
      fromLeft
    />
  );

  return (
    <div className="w-full flex-1 flex flex-col my-2 overflow-auto">
      <div className="toolbar bg-gray-200 p-2 flex gap-1 flex-wrap">
        <div className="flex gap-1 items-center">
          <ToolButton
            icon="format_bold"
            onClick={() => handleSpecialCommand("bold")}
            active={activeFormats.has("bold")}
            title="Bold"
          />
          <ToolButton
            icon="format_italic"
            onClick={() => handleSpecialCommand("italic")}
            active={activeFormats.has("italic")}
            title="Italic"
          />
          <ToolButton
            icon="format_underlined"
            onClick={() => handleSpecialCommand("underline")}
            active={activeFormats.has("underline")}
            title="Underline"
          />
          <ToolButton
            icon="subscript"
            onClick={() => handleSpecialCommand("subscript")}
            active={activeFormats.has("subscript")}
            title="Subscript"
          />
          <ToolButton
            icon="superscript"
            onClick={() => handleSpecialCommand("superscript")}
            active={activeFormats.has("superscript")}
            title="Superscript"
          />
          <ToolButton
            icon="format_clear"
            onClick={() => handleSpecialCommand("clearFormat")}
            title="Clear Format"
          />
        </div>
        <Divider orientation="vertical" />
        <div className="flex flex-wrap gap-1 items-center">
          <DropdownMenu
            MenuSection={
              <div className="p-2 flex flex-col gap-1">
                <DropdownButton
                  title={"Header 1"}
                  icon="format_h1"
                  onClick={() => handleSpecialCommand("heading", "h1")}
                />
                <DropdownButton
                  title={"Header 2"}
                  icon="format_h2"
                  onClick={() => handleSpecialCommand("heading", "h2")}
                />
                <DropdownButton
                  title={"Header 3"}
                  icon="format_h3"
                  onClick={() => handleSpecialCommand("heading", "h3")}
                />
                <DropdownButton
                  title={"Header 4"}
                  icon="format_h4"
                  onClick={() => handleSpecialCommand("heading", "h4")}
                />
                <DropdownButton
                  title={"Header 5"}
                  icon="format_h5"
                  onClick={() => handleSpecialCommand("heading", "h5")}
                />
                <DropdownButton
                  title={"Header 6"}
                  icon="format_h6"
                  onClick={() => handleSpecialCommand("heading", "h6")}
                />
                <DropdownButton
                  title={"Normal Text"}
                  onClick={() => handleSpecialCommand("heading", "p")}
                />
              </div>
            }
          >
            <Button
              type="icon"
              variant="text"
              color="black"
              icon="text_format"
              size="sm"
              className="rounded-none gap-0.5 !px-5"
              ddMenu
            />
          </DropdownMenu>
          <DropdownMenu
            MenuSection={
              <div className="p-2 flex flex-col gap-1">
                <DropdownButton
                  title={"Arial"}
                  onClick={() => handleSpecialCommand("fontFamily", "Arial")}
                  active={selectedFont === "Arial"}
                />
                <DropdownButton
                  title={"Times New Roman"}
                  onClick={() =>
                    handleSpecialCommand("fontFamily", "Times New Roman")
                  }
                  active={selectedFont === "Times New Roman"}
                />
                <DropdownButton
                  title={"Courier New"}
                  onClick={() =>
                    handleSpecialCommand("fontFamily", "Courier New")
                  }
                  active={selectedFont === "Courier New"}
                />
                <DropdownButton
                  title={"Verdana"}
                  onClick={() => handleSpecialCommand("fontFamily", "Verdana")}
                  active={selectedFont === "Verdana"}
                />
                <DropdownButton
                  title={"Georgia"}
                  onClick={() => handleSpecialCommand("fontFamily", "Georgia")}
                  active={selectedFont === "Georgia"}
                />
                <DropdownButton
                  title={"Tahoma"}
                  onClick={() => handleSpecialCommand("fontFamily", "Tahoma")}
                  active={selectedFont === "Tahoma"}
                />
              </div>
            }
          >
            <Button
              type="icon"
              variant="text"
              color="black"
              icon="serif"
              size="sm"
              className="rounded-none gap-0.5 !px-5"
              ddMenu
            />
          </DropdownMenu>
          <DropdownMenu
            MenuSection={
              <div className="p-2 flex flex-col gap-1">
                <DropdownButton
                  title={"Font Size 10"}
                  onClick={() => handleSpecialCommand("fontSize", "10")}
                  active={selectedFontSize === "10"}
                />
                <DropdownButton
                  title={"Font Size 12"}
                  onClick={() => handleSpecialCommand("fontSize", "12")}
                  active={selectedFontSize === "12"}
                />
                <DropdownButton
                  title={"Font Size 14"}
                  onClick={() => handleSpecialCommand("fontSize", "14")}
                  active={selectedFontSize === "14"}
                />
                <DropdownButton
                  title={"Font Size 16"}
                  onClick={() => handleSpecialCommand("fontSize", "16")}
                  active={selectedFontSize === "16"}
                />
                <DropdownButton
                  title={"Font Size 18"}
                  onClick={() => handleSpecialCommand("fontSize", "18")}
                  active={selectedFontSize === "18"}
                />
                <DropdownButton
                  title={"Font Size 20"}
                  onClick={() => handleSpecialCommand("fontSize", "20")}
                  active={selectedFontSize === "20"}
                />
                <DropdownButton
                  title={"Font Size 24"}
                  onClick={() => handleSpecialCommand("fontSize", "24")}
                  active={selectedFontSize === "24"}
                />
              </div>
            }
          >
            <Button
              type="icon"
              variant="text"
              color="black"
              icon="text_fields"
              size="sm"
              className="rounded-none gap-0.5 !px-5"
              ddMenu
            />
          </DropdownMenu>
          <DropdownMenu
            MenuSection={
              <div className="p-2 flex flex-col gap-1">
                <DropdownButton
                  title={"Line Height 1"}
                  onClick={() => handleSpecialCommand("lineHeight", "1")}
                  active={selectedLineHeight === "1"}
                />
                <DropdownButton
                  title={"Line Height 1.2"}
                  onClick={() => handleSpecialCommand("lineHeight", "1.2")}
                  active={selectedLineHeight === "1.2"}
                />
                <DropdownButton
                  title={"Line Height 1.4"}
                  onClick={() => handleSpecialCommand("lineHeight", "1.4")}
                  active={selectedLineHeight === "1.4"}
                />
                <DropdownButton
                  title={"Line Height 1.6"}
                  onClick={() => handleSpecialCommand("lineHeight", "1.6")}
                  active={selectedLineHeight === "1.6"}
                />
                <DropdownButton
                  title={"Line Height 1.8"}
                  onClick={() => handleSpecialCommand("lineHeight", "1.8")}
                  active={selectedLineHeight === "1.8"}
                />
                <DropdownButton
                  title={"Line Height 2"}
                  onClick={() => handleSpecialCommand("lineHeight", "2")}
                  active={selectedLineHeight === "2"}
                />
              </div>
            }
          >
            <Button
              type="icon"
              variant="text"
              color="black"
              icon="line_weight"
              size="sm"
              className="rounded-none gap-0.5 !px-5"
              ddMenu
            />
          </DropdownMenu>
        </div>
        <Divider orientation="vertical" />
        <div className="flex gap-1 items-center">
          <ToolButton
            icon="add_link"
            onClick={() => handleSpecialCommand("link")}
            title="Add Link"
          />
          <ToolButton
            icon="photo"
            onClick={() => handleSpecialCommand("image")}
            title="Insert Image"
          />
          <ToolButton icon="videocam" title="Insert Video" />
          <ToolButton icon="attach_file_add" title="Attach File" />
          <ToolButton
            icon="format_list_bulleted"
            onClick={() => handleSpecialCommand("insertUnorderedList")}
            active={activeFormats.has("bulletList")}
            title="Bullet List"
          />
          <ToolButton
            icon="format_list_numbered"
            onClick={() => handleSpecialCommand("insertOrderedList")}
            active={activeFormats.has("numberedList")}
            title="Numbered List"
          />
          <ToolButton
            icon="format_quote"
            onClick={() => handleSpecialCommand("formatBlock", "blockquote")}
            title="Quote"
          />
          <ToolButton icon="format_color_text" title="Text Color" />
          <ToolButton icon="format_color_fill" title="Background Color" />
        </div>
        <div className="flex gap-1 items-center">
          <ToolButton
            icon="format_align_left"
            onClick={() => handleSpecialCommand("justifyLeft")}
            active={activeFormats.has("alignLeft")}
            title="Align Left"
          />
          <ToolButton
            icon="format_align_center"
            onClick={() => handleSpecialCommand("justifyCenter")}
            active={activeFormats.has("alignCenter")}
            title="Align Center"
          />
          <ToolButton
            icon="format_align_right"
            onClick={() => handleSpecialCommand("justifyRight")}
            active={activeFormats.has("alignRight")}
            title="Align Right"
          />
          <ToolButton
            icon="format_align_justify"
            onClick={() => handleSpecialCommand("justifyFull")}
            active={activeFormats.has("alignJustify")}
            title="Justify"
          />
          <ToolButton
            icon="format_indent_increase"
            onClick={() => handleSpecialCommand("indent")}
            title="Increase Indent"
          />
          <ToolButton
            icon="format_indent_decrease"
            onClick={() => handleSpecialCommand("outdent")}
            title="Decrease Indent"
          />
        </div>
        <Divider orientation="vertical" />
      </div>
      <div className="textArea bg-gray-50 border border-gray-200 p-2 min-h-[200px]">
        <div
          ref={editorRef}
          className="editor-content w-full min-h-[180px] max-h-[600px] outline-none resize-y overflow-auto"
          contentEditable
          placeholder={placeholder}
          suppressContentEditableWarning
          onInput={handleContentChange}
          onKeyUp={updateActiveFormats}
          onMouseUp={updateActiveFormats}
          style={{
            lineHeight: selectedLineHeight,
            fontFamily: selectedFont,
            fontSize: selectedFontSize + "px",
          }}
        />
      </div>
      <div className="textAreaBottom bg-gray-200 p-2 text-sm text-gray-600">
        <div className="flex justify-between items-center">
          <span>Rich Text Editor</span>
          <span>
            {selectedFont} • {selectedFontSize}px • Line height:{" "}
            {selectedLineHeight}
          </span>
        </div>
      </div>

      {/* Add Material Icons */}
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
    </div>
  );
};

export default CustomTextEditor;
